import { FC } from 'react'

// import Sber from 'images/sber-bank-logo-white.svg'
import Webpay from 'images/webpay-logo-white.svg'
import Visa from 'images/visa-logo-white.svg'
import VisaSecure from 'images/visa-secure-logo-white.svg'
import MasterCard from 'images/mastercard-logo-white.svg'
import MasterCardIdCheck from 'images/mastercard-idcheck-logo-white.svg'
import Belkart from 'images/belkart-logo-white.svg'
import BelkartParol from 'images/belkart-internet-parol-logo-white.svg'

type TProps = {}

const METHODS = [
  // Sber,
  Webpay,
  Visa,
  VisaSecure,
  MasterCard,
  MasterCardIdCheck,
  Belkart,
  BelkartParol,
]

const PaymentMethods: FC<TProps> = () => {
  return (
    <div className="flex w-full h-20 justify-center gap-4 px-30">
      {METHODS.map((MethodImg, index) => (
        <div key={index} className="h-full">
          <img src={MethodImg} className="h-full"></img>
        </div>
      ))}
    </div>
  )
}

export { PaymentMethods }
